export class Address {
    pk?: number;
    line_1?: string;
    line_2?: string;
    line_3?: string;
    pick_up_parish?: string;
    zipcode?: string;
    user?: string
}